import { toggleMaxHeight } from './helper'


document.addEventListener('DOMContentLoaded', () => {
    const scrollTriggerValue = 200;

    const elements = {
        'header': document.querySelector('.header'),
        'menuToggle': document.querySelector('.js-toggleNav'),
        'menu': document.querySelector('.header__navigation')
    }

    const classes = {
        'scrolled': 'scrolled',
        'open': 'open',
        'active': 'active'
    }

    const toggleMenu = () => {
        toggleMaxHeight(elements.menu as HTMLElement);
        elements.menu.classList.toggle(classes.open);
        elements.menuToggle.classList.toggle(classes.active);
    }

    const handleScroll = () => {
        if(window.scrollY >= scrollTriggerValue) {
            elements.header.classList.add(classes.scrolled);
        } else {
            elements.header.classList.remove(classes.scrolled);
        }
    }

    window.addEventListener('scroll', handleScroll);
    elements.menuToggle.addEventListener('click', toggleMenu);

    handleScroll();
})